import { HOKAGE_MIGRATION_ROLLOUT } from "~/constants/hokageMigration";
import { isAfterHokageServiceCutoff } from "~/utils/hokageServiceCutoff";
import { checkAllowedIp } from "./allowedIp";
import { isHokageApp, isHokageFamilyApp } from "./applicationId";

// 移行対象は Hokage(93) だけ。BE（Jambo-Server HokageCarinaMigrationService）が 93→95 しか移行しないため、
// オーガニック(1093) には移行 UI を出さない。

/**
 * 9774（移行済み）の振り分けと /hokage-migrated を有効にするか（同期判定）。
 * 9774 は移行済みユーザーにしか返らないため、IP は見ず rollout が "off" 以外なら有効。
 */
export const isHokageMigratedRoutingEnabled = (): boolean =>
  HOKAGE_MIGRATION_ROLLOUT !== "off" && isHokageApp();

/** 移行 UI を出すか。"office" のときは社内 IP 判定の結果（isOfficeIp）が必要 */
export const isHokageMigrationVisible = (isOfficeIp: boolean): boolean => {
  if (!isHokageApp()) return false;
  if (HOKAGE_MIGRATION_ROLLOUT === "all") return true;
  return HOKAGE_MIGRATION_ROLLOUT === "office" && isOfficeIp;
};

/** route の beforeLoad 用。"office" のときだけ IP 判定を await する */
export const resolveHokageMigrationVisible = async (): Promise<boolean> => {
  if (!isHokageApp()) return false;
  if (HOKAGE_MIGRATION_ROLLOUT === "office") {
    return isHokageMigrationVisible(await checkAllowedIp());
  }
  return isHokageMigrationVisible(false);
};

/** Hokage(93/1093) で締め切り以降なら true（ガードはログアウトしてサービス終了画面へ送る） */
export const shouldBlockHokageService = (now: Date = new Date()): boolean =>
  isHokageFamilyApp() && isAfterHokageServiceCutoff(now);
